import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=12347494&"
import script from "./contract.vue?vue&type=script&lang=js&"
export * from "./contract.vue?vue&type=script&lang=js&"
import style0 from "./contract.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports